import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, injectIntl } from 'react-intl'
import TextTruncate from 'react-text-truncate'
import { OEComponents } from '@opportunityeducation/oe-web-common'

import ReviewCheckbox from './ReviewCheckbox'
import UserAvatar from '../../../mini/UserAvatar'
import ToQualityReviewModal from './ToQualityReviewModal'
import UserName from '../../../mini/UserName'

import {
  setApproved,
  setLastApproval,
  deleteApproval
} from '../../../../actions/approval'
import {
  openToQualityReviewModal,
  closeToQualityReviewModal
} from '../../../../actions/review'
import { messages } from '../../../../utils/messages/descriptions'
import { reviewer } from '../../../../utils/messages'
import { getUserDisplayName } from '../../../../utils/name'

export class InternalReviewBox extends Component {
  constructor(props) {
    super(props)
    this.setApprovedBound = this.setApproved.bind(this)
    this.handleConfirmClickBound = this.handleConfirmClick.bind(this)
    this.handleCancelClickBound = this.handleCancelClick.bind(this)
    this.state = {
      finalApprovalNeeded: false
    }
  }

  componentDidMount() {
    this.props.dispatch(closeToQualityReviewModal())
  }

  render() {
    const { type, approval, quest, toQualityReviewModalIsOpen, intl } =
      this.props

    const typeString = type.props.defaultMessage.toLowerCase()
    const description = intl.formatMessage(messages[typeString])
    const klass = approval ? 'approved' : ''

    return (
      <div className={`internal-review-box ${klass}`}>
        <div className="header">{type}</div>
        {!approval && <div className="info">{description}</div>}
        {approval && (
          <div className="approval">
            <div className="approved-by">
              <FormattedMessage
                id={'InternalReview.ApprovedBy'}
                defaultMessage={'Approved by:'}
              />
            </div>

            <div className="avatar-wrapper">
              <UserAvatar photoUrl={approval.approved_by.photo_url} />
              <div className="user">
                <UserName
                  activeCertifications={
                    approval.approved_by.active_certifications
                  }
                  userId={`approval-${type}-${approval.approved_by.id}`}
                  rebuild
                >
                  <div className="name">
                    <TextTruncate
                      line={2}
                      truncateText="..."
                      text={getUserDisplayName(approval.approved_by)}
                    />
                  </div>
                </UserName>
                <div className="role">{reviewer}</div>
              </div>
            </div>

            <div className="timestamp">
              <OEComponents.DateFormatter
                date={approval.created_at}
                includeTime={false}
              />
              {' at '}
              <OEComponents.Time time={approval.created_at} />
            </div>
          </div>
        )}
        <ReviewCheckbox
          {...this.props}
          setApproved={this.setApprovedBound}
          approved={Boolean(approval)}
        />
        {toQualityReviewModalIsOpen && this.state.finalApprovalNeeded && (
          <ToQualityReviewModal
            quest={quest}
            handleConfirmClick={this.handleConfirmClickBound}
            handleCancelClick={this.handleCancelClickBound}
            criteria={typeString}
            isSettingLastApproval={this.props.isSettingLastApproval}
          />
        )}
      </div>
    )
  }

  setApproved(e) {
    const { quest, type, approval, approvals, dispatch, isEditingApproval } =
      this.props
    if (isEditingApproval) {
      // block the action (click) if one is already in progress
      return e.preventDefault()
    }
    const criteria = type.props.defaultMessage.toLowerCase()
    if (approval) {
      dispatch(deleteApproval(quest.id, approval.id))
    } else {
      if (approvals.length === 2) {
        this.setState(() => ({ finalApprovalNeeded: true }))
        dispatch(openToQualityReviewModal())
      } else {
        dispatch(setApproved(quest.id, criteria))
      }
    }
  }

  async handleCancelClick() {
    await this.setState(() => ({ finalApprovalNeeded: false }))
    this.props.dispatch(closeToQualityReviewModal())
  }

  handleConfirmClick(criteria) {
    const { dispatch, quest } = this.props
    dispatch(setLastApproval(quest.id, criteria))
  }
}

InternalReviewBox.propTypes = {
  type: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  quest: PropTypes.object.isRequired,
  organization: PropTypes.object.isRequired,
  handleAssignClick: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  approval: PropTypes.object,
  approvals: PropTypes.array,
  toQualityReviewModalIsOpen: PropTypes.bool.isRequired,
  intl: PropTypes.object.isRequired,
  isEditingApproval: PropTypes.bool.isRequired,
  isSettingLastApproval: PropTypes.bool.isRequired
}

export default injectIntl(InternalReviewBox)



// WEBPACK FOOTER //
// ./src/components/quest/review/internalreview/InternalReviewBox.js